import moment from 'moment'

import { type FamilyMembersList } from '~/services/family-services'

interface ParticipantDraft {
  familyData: {
    countFamilyMembers: number | null | undefined
    familyMembersList: Array<
      Omit<Partial<FamilyMembersList>, 'birthDate'> & {
        birthDate?: number | null
      }
    >
  }
}

interface CountryOption {
  id: string
  label: string
}

interface CallingCodeOption extends CountryOption {
  code: string
}

export function getPrimaryParticipantFormValues(
  draft: ParticipantDraft,
  countryOptions: CountryOption[],
  callingCodeOptions: CallingCodeOption[],
  defaultCountry: string,
  contactEmail: string | null,
) {
  const member = draft.familyData.familyMembersList[0]
  const phoneCode = member?.phoneCode?.trim().replace(/^\+/, '')
  const savedBirthCountry = member?.birthCountry?.trim().toUpperCase()
  const birthCountry = savedBirthCountry?.length
    ? savedBirthCountry
    : defaultCountry
  const birthDate = member?.birthDate
  const countFamilyMembers: number | '' =
    draft.familyData.countFamilyMembers ?? ''

  return {
    firstName: member?.firstName ?? '',
    lastName: member?.lastName ?? '',
    gender: member?.gender ?? '',
    customGender: member?.customGender ?? undefined,
    birthDate:
      typeof birthDate === 'number' && Number.isFinite(birthDate)
        ? moment.unix(birthDate)
        : null,
    birthCountry:
      countryOptions.find(country => country.id === birthCountry) ?? null,
    documentType: member?.documentType ?? '',
    customDocumentType: member?.customDocumentType ?? undefined,
    documentNumber: member?.documentNumber ?? '',
    countFamilyMembers,
    email: member?.email ?? contactEmail ?? '',
    emailVerificationCode: member?.emailVerificationCode ?? '',
    isEmailVerified: member?.isEmailVerified ?? false,
    phone: {
      number: member?.phoneNumber ?? '',
      code:
        (phoneCode
          ? callingCodeOptions.find(option => option.id === phoneCode)
          : callingCodeOptions.find(
              option =>
                option.code ===
                (defaultCountry === 'CA' ? 'US' : defaultCountry),
            )) ?? null,
    },
  }
}
